<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Lista de productos y servicios.
                Crea, edita o desactiva materiales;
                define unidades y datos clave.
                Úsalo antes de vender o mover inventario
                para evitar errores.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Materiales
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina las <b>materiales</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Materiales</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button mat-stroked-button *ngIf="!isEditSort" color="primary" (click)="isEditSort = !isEditSort">
            <mat-icon svgIcon="heroicons_solid:arrows-up-down"></mat-icon>
            <span>Editar Posición</span>
          </button>
          <button mat-icon-button *ngIf="isEditSort" (click)="onsaveChangesOrder()" matTooltip="Guardar">
            <mat-icon color="success" svgIcon="mat_outline:save"></mat-icon>
          </button>
          <!-- <button mat-icon-button *ngIf="isEditSort" (click)="isEditSort=!isEditSort" matTooltip="Cancelar Posición">
            <mat-icon color="warn" svgIcon="heroicons_outline:x-mark"></mat-icon>
          </button> -->
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn"
              matSortDisableClear multiTemplateDataRows cdkDropList #listGroup="cdkDropList"
              [cdkDropListData]="dataSource" (cdkDropListDropped)="onListDrop($event)">
              <!-- Código  y nombre-->
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Material
                </th>
                <td mat-cell *matCellDef="let material" class="text-sm uppercase leading-tight">
                  <b style="font-size: 10px">{{ material.code }}</b><br />
                  {{ material.name }}
                </td>
              </ng-container>

              <!-- Precio -->
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Precio {{ 'code' | companyCurrency: true }}
                </th>
                <td mat-cell *matCellDef="let material" class="text-sm uppercase">
                  {{ material.price | moneda }}
                </td>
              </ng-container>

              <!-- Precio Costo(solo si hay integración con ERP) -->
              <ng-container matColumnDef="costPrice">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Precio de Costo
                </th>
                <td mat-cell *matCellDef="let material" class="text-sm uppercase">
                  {{ material.costPrice | moneda }}
                </td>
              </ng-container>


              <!-- Compañía -->
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Compañía
                </th>
                <td mat-cell *matCellDef="let material" class="text-sm uppercase">
                  {{ material.company?.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="inventory">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                  Ventas sin inventario
                </th>
                <td mat-cell *matCellDef="let material" class="px-6 text-left">
                  <mat-form-field appearance="fill" style="width: 150px;" floatLabel="never">
                    <mat-select [(ngModel)]="material.canMakeAnOrderWithoutStock"
                      (selectionChange)="onInventoryChange($event, material)">

                      <mat-option *ngFor="let wStock of orderWithoutStockList" [value]="wStock.value">
                        {{ wStock.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>

              <!-- UMP -->
              <!-- <ng-container matColumnDef="UMPActive">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="px-6 text-left"
              >
                UMP Activo
              </th>
              <td mat-cell *matCellDef="let material" class="px-6 text-left">
                {{ material.UMPActive ? "Si" : "No" }}
              </td>
            </ng-container> -->
              <!-- 
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>Posición</th>
              <td mat-cell *matCellDef="let element">{{ element.position }}</td>
            </ng-container> -->

              <!-- Grupos de Materiales -->
              <!-- <ng-container matColumnDef="materialGroup">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Grupo de Material</th>
              <td mat-cell *matCellDef="let material" class="px-6 text-left">
                <ng-container *ngFor="let group of material.materialGroup">
                  {{ group.name }}<br>
                </ng-container>
              </td>
            </ng-container> -->

              <!-- Estado -->
              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                  Estado
                </th>
                <td mat-cell *matCellDef="let material" class="px-6 text-left">
                  <mat-slide-toggle [checked]="material.statusId == true"
                    (change)="onStatusChange($event.checked, material)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let material" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(material)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openWarehouseManagementModal(material)">
                      <mat-icon>warehouse</mat-icon>
                      <span>Gestionar Almacenes</span>
                    </button>
                    <button mat-menu-item (click)="openUnitModal(material)">
                      <mat-icon svgIcon="heroicons_outline:calendar"></mat-icon>
                      <span>U. de Medida Alternativa</span>
                    </button>
                    <button mat-menu-item (click)="openOrderModal(material)">
                      <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
                      <span>Vnas. Horarias de Entrega</span>
                    </button>
                    @if (projectName != "DIUNSA") {
                    <button mat-menu-item (click)="openImagesModal(material)">
                      <mat-icon svgIcon="heroicons_outline:photo"></mat-icon>
                      <span>Imágenes</span>
                    </button>
                    }
                    <button mat-menu-item (click)="openDeleteDialog(material)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row"
                [cdkDragDisabled]="!isEditSort" [ngStyle]="{ cursor: isEditSort ? 'ns-resize' : 'null' }"
                class="border-b"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold pb-4 border-b border-gray-200 dark:border-gray-700">Nuevo Registro</h2>
      <mat-dialog-content class="overflow-y-auto p-6" style="max-height: 70vh;">
        <form #createForm="ngForm" class="flex flex-col gap-y-5">

                <!-- SECCIÓN: Información Básica -->
                <app-form-section
                  title="Información Básica"
                  icon="inventory_2"
                  color="blue"
                  class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Código</mat-label>
                        <input matInput [(ngModel)]="currentCreateMaterial.code" name="code" required />
                      </mat-form-field>
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Código de Barras</mat-label>
                        <input matInput [(ngModel)]="currentCreateMaterial.barcode" name="barcode" />
                      </mat-form-field>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Nombre</mat-label>
                        <input matInput [(ngModel)]="currentCreateMaterial.name" name="name" required />
                      </mat-form-field>
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Referencia</mat-label>
                        <input matInput [(ngModel)]="currentCreateMaterial.reference" name="reference" />
                      </mat-form-field>
                    </div>
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Descripción Larga</mat-label>
                      <input matInput [(ngModel)]="currentCreateMaterial.descriptionLong" name="descriptionLong" required />
                    </mat-form-field>
                    <div class="grid grid-cols-2 gap-4">
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Descripción Corta</mat-label>
                        <input matInput [(ngModel)]="currentCreateMaterial.descriptionShort" name="descriptionShort" required />
                      </mat-form-field>
                    <!-- Columna 2: grid interna con los dos precios -->
                    <div class="grid grid-cols-2 gap-2">
                      <!-- Precio de Venta -->
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Precio</mat-label>
                        <input type="number" matInput [(ngModel)]="currentCreateMaterial.price" name="price" required min="0" />
                      </mat-form-field>
                    
                      <!-- Precio de Costo -->
                        <mat-form-field appearance="fill" class="w-full">
                          <mat-label>Precio de Costo</mat-label>
                          <input type="number" matInput [(ngModel)]="currentCreateMaterial.costPrice" name="costPrice" [disabled]="ERPActive"
                            min="0"
                           (blur)="formatCostPrice(currentCreateMaterial)"
                            [matTooltip]="ERPActive ? 'El precio de costo se gestiona desde el ERP.' : ''" matTooltipPosition="above" />
                        </mat-form-field>
                    </div>
                    </div>
                  </div>
                </app-form-section>

                <!-- SECCIÓN: Configuración de Producto -->
                <app-form-section
                  title="Configuración de Producto"
                  icon="category"
                  color="green"
                  class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Compañía</label>
                        <ng-select [(ngModel)]="currentCreateMaterial.companyId" [items]="companyList" bindLabel="name"
                          bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía" name="companyId"
                          [appendTo]="'body'" required>
                        </ng-select>
                      </div>
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">División</label>
                        <ng-select [(ngModel)]="currentCreateMaterial.divisionId" [items]="divisionList" bindLabel="name"
                          bindValue="_id" [searchable]="true" placeholder="Seleccione una división" name="divisionId"
                          [appendTo]="'body'" required>
                        </ng-select>
                      </div>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Requisitos</mat-label>
                        <mat-select name="requirementId" [(ngModel)]="currentCreateMaterial.requirementId"
                          placeholder="Seleccione requisitos(s)" multiple>
                          <mat-option *ngFor="let req of requirementList" [value]="req._id">{{ req.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Clasificación</mat-label>
                        <mat-select name="classifications" [(ngModel)]="currentCreateMaterial.classifications">
                          <mat-option *ngFor="let classification of classificationList" [value]="classification.value">{{
                            classification.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Marca de Material</label>
                        <ng-select [(ngModel)]="currentCreateMaterial.materialBrandId" [items]="materialBrandList" bindLabel="name"
                          bindValue="_id" [searchable]="true" placeholder="Seleccione una marca" name="materialBrandId"
                          [appendTo]="'body'">
                        </ng-select>
                      </div>
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Material</label>
                        <ng-select [(ngModel)]="currentCreateMaterial.materialTypeId" [items]="materialTypeList" bindLabel="name"
                          bindValue="_id" [searchable]="true" placeholder="Seleccione un tipo de material" name="materialTypeId"
                          [appendTo]="'body'">
                        </ng-select>
                      </div>
                    </div>
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Grupo de Material</mat-label>
                      <mat-select [(ngModel)]="currentCreateMaterial.materialGroupId" name="materialGroupId" multiple required>
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchMaterialGroup" [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="
                    isProjectTree
                      ? filterTree($event)
                      : changueOptionsGroupMaterial($event)
                  " placeholderLabel="Buscar..." noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
              </mat-option>

              @if (!isProjectTree) {
              @for (group of listCategories; track group) {
              <mat-option [value]="group._id">
                <b>{{ group.code }}</b> - {{ group.name }}
              </mat-option>
              }
              } @else {
              <mat-optgroup *ngFor="let group of listCategories" [label]="group.name">
                <mat-option *ngFor="let subgroup of group.children" [value]="subgroup._id">
                  <ng-container *ngIf="getCode(subgroup) as code">
                    <b class="f-12">{{ code }}</b> -
                  </ng-container>
                  {{ subgroup.name }}
                </mat-option>
              </mat-optgroup>
              }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </app-form-section>

                <!-- SECCIÓN: Unidades de Medida -->
                <app-form-section
                  title="Unidades de Medida"
                  icon="straighten"
                  color="purple"
                  class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Embalaje</mat-label>
                        <mat-select [(ngModel)]="currentCreateMaterial.isPackaged" name="isPackaged">
                          <mat-option *ngFor="let material of materialPackagedList" [value]="material.value">
                            {{ material.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Ventas sin Inventario</mat-label>
                        <mat-select [(ngModel)]="currentCreateMaterial.canMakeAnOrderWithoutStock" name="canMakeAnOrderWithoutStock">
                          <mat-option *ngFor="let wStock of orderWithoutStockList" [value]="wStock.value">
                            {{ wStock.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidad de Medida Base</label>
                        <ng-select [(ngModel)]="currentCreateMaterial.baseunitMeasurementId" [items]="baseUnitOfMeasuresList"
                          bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una unidad de medida"
                          name="baseunitMeasurementId" [appendTo]="'body'" (ngModelChange)="onBaseMeasurestUnitChange($event)"
                          required>
                        </ng-select>
                      </div>

                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidad de Medida de Distribución</label>
                        <ng-select [(ngModel)]="currentCreateMaterial.distributionunitMeasurementId"
                          [items]="baseUnitOfMeasuresList" bindLabel="name" bindValue="_id" [searchable]="true"
                          placeholder="Seleccione una unidad de medida" name="baseunitDistributionId"
                          [appendTo]="'body'" required>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </app-form-section>

                <!-- SECCIÓN: Configuraciones Adicionales -->
                <app-form-section
                  title="Configuraciones Adicionales"
                  icon="tune"
                  color="orange"
                  class="space-y-4 mb-4">
                  <div class="flex flex-col gap-y-4">
                    <app-toggle-option
                      [(ngModel)]="currentCreateMaterial.UMPActive"
                      name="UMPActive"
                      title="Unidad de Medida Paralela"
                      description="Activa esta opción si el material usará unidades de medida paralelas (UMP) para su gestión"
                      icon="swap_horiz"
                      iconColor="purple">
                    </app-toggle-option>

                    <app-toggle-option
                      [(ngModel)]="currentCreateMaterial.batchControlActive"
                      name="batchControlActive"
                      title="Control Activo de Lote"
                      description="Activa esta opción si el material requiere control de lotes para trazabilidad"
                      icon="inventory"
                      iconColor="orange">
                    </app-toggle-option>
                  </div>
                </app-form-section>

          <!-- SECCIÓN: Almacenes -->
          <app-material-warehouse-assignment
            [selectedWarehouses]="currentCreateMaterial.warehouseIds || []"
            [availableInAllWarehouses]="currentCreateMaterial.availableInAllWarehouses || false"
            (warehousesChange)="onWarehousesChange($event)"
            (formValidityChange)="onWarehouseValidityChange($event)">
          </app-material-warehouse-assignment>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="currentCreateMaterial"
          [disabled]="!createForm.valid">
          <!--|| groupMultiCtrl.invalid-->
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Agregar Unidad Paralela -->
    <ng-template #addModalUnit>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Unidades de Medida Alternativa
      </h2>
      <mat-dialog-content class="modal-content">
        <!-- <div class="flex justify-end mb-2" *ngIf="!showAddUnitForm">
     
        </div>     -->
        <!-- Tabla de Unidades Existentes -->
        <table mat-table [dataSource]="currentUpdateMaterial.alternalUnitOfMeasures"
          class="min-w-500 overflow-y-visible mat-elevation-z">
          <ng-container matColumnDef="info">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" [matTooltip]="
                            element.isUMB
                              ? 'Unidad de Medida Base'
                              : element.isUMP
                                ? 'Unidad de Medida Paralela'
                                : element.isCommercialUom
                                  ? 'Unidad Medida Venta'
                                  : ''
                          " class="text-sm font-semibold">
              {{
              element.isUMB
              ? "UMB"
              : element.isUMP
              ? "UMP"
              : element.isCommercialUom
              ? "UMV"
              : ""
              }}
            </td>

          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef>Cantidad</th>
            <td mat-cell *matCellDef="let element">
              {{ element.quantity }}
            </td>
          </ng-container>

          <ng-container matColumnDef="unitOfMeasure">
            <th mat-header-cell *matHeaderCellDef>U.M.Alternativa</th>
            <td mat-cell *matCellDef="let element">
              {{ element.unitOfMeasure?.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="equivalentQuantity">
            <th mat-header-cell *matHeaderCellDef>Cnt.Equivalente</th>
            <td mat-cell *matCellDef="let element">
              {{ element.equivalentQuantity }}
            </td>
          </ng-container>

          <ng-container matColumnDef="baseUnitofMeasure">
            <th mat-header-cell *matHeaderCellDef>U.M.Base</th>
            <td mat-cell *matCellDef="let element">
              {{
              element.isUMB
              ? element.unitOfMeasure?.name
              : this.currentUpdateMaterial.baseUnitOfMeasure?.name
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="barcode">
            <th mat-header-cell *matHeaderCellDef>Cód. Barra U.M.A.</th>
            <td mat-cell *matCellDef="let element">
              {{ element.barcode ? element.barcode : "" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              <button color="primary" mat-button (click)="openAddUnitModal()" matTooltip="Agregar Unidad">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="button-container">
                <button mat-icon-button (click)="openAddUnitModal(element)" [disabled]="isBaseUnit(element)">
                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                </button>
                <button mat-icon-button (click)="openDeleteUnit(element)" [disabled]="isBaseUnit(element)">
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsUMP"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsUMP"></tr>
        </table>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deliveryModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Ventanas Horarias de Entrega
      </h2>
      <mat-dialog-content class="modal-content">
        <!-- Tabla de Order Delivery -->
        <table mat-table [dataSource]="currentUpdateMaterial.orderDeliveryWindows"
          class="min-w-500 overflow-y-visible mat-elevation-z">
          <ng-container matColumnDef="days">
            <th mat-header-cell *matHeaderCellDef>Dias</th>
            <td mat-cell *matCellDef="let element">
              {{ getDayNames(element.days) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="hourStart">
            <th mat-header-cell *matHeaderCellDef>Hora Inicio</th>
            <td mat-cell *matCellDef="let element">
              {{ element.hourStart }}
            </td>
          </ng-container>

          <ng-container matColumnDef="hourEnd">
            <th mat-header-cell *matHeaderCellDef>Hora Fin</th>
            <td mat-cell *matCellDef="let element">
              {{ element.hourEnd }}
            </td>
          </ng-container>

          <ng-container matColumnDef="numberOfHoursToDelivery">
            <th mat-header-cell *matHeaderCellDef>Horas para Entrega</th>
            <td mat-cell *matCellDef="let element">
              {{ element.numberOfHoursToDelivery }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
              Estado
            </th>
            <td mat-cell *matCellDef="let element" class="px-6 text-left">
              <mat-slide-toggle [checked]="element.statusId == 1"
                (change)="onStatusOrderChange($event.checked, element)" color="primary">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              <button color="primary" mat-button (click)="openAddOrderModal()" matTooltip="Agregar Orden">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="button-container">
                <button mat-icon-button (click)="openAddOrderModal(element)">
                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                </button>
                <button mat-icon-button (click)="openDeleteOrder(element)">
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsOrder"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsOrder"></tr>
        </table>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Editar Registro - {{ this.currentUpdateMaterial.name }}
      </h2>
      <mat-dialog-content class="overflow-y-auto p-6" style="max-height: 70vh;">
        <mat-tab-group>
          <mat-tab label="Datos Material">
            <form #editForm="ngForm" class="flex flex-col gap-y-5 pt-4">

              <!-- SECCIÓN: Información Básica -->
              <app-form-section
                title="Información Básica"
                icon="inventory_2"
                color="blue"
                class="space-y-4 mb-4">
                <div class="space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Código</mat-label>
                      <input matInput [(ngModel)]="currentUpdateMaterial.code" name="code" disabled />
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Código de Barras</mat-label>
                      <input matInput [(ngModel)]="currentUpdateMaterial.barcode" name="barcode" />
                    </mat-form-field>
                  </div>
                  <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Nombre</mat-label>
                      <input matInput [(ngModel)]="currentUpdateMaterial.name" name="name" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Referencia</mat-label>
                      <input matInput [(ngModel)]="currentUpdateMaterial.reference" name="reference" />
                    </mat-form-field>
                  </div>
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Descripción Larga</mat-label>
                    <input matInput [(ngModel)]="currentUpdateMaterial.descriptionLong" name="descriptionLong" required />
                  </mat-form-field>
                  <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Descripción Corta</mat-label>
                      <input matInput [(ngModel)]="currentUpdateMaterial.descriptionShort" name="descriptionShort" required />
                    </mat-form-field>
                    <div class="grid grid-cols-2 gap-2">
                      <!-- Precio de Venta -->
                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Precio</mat-label>
                        <input type="number" matInput [(ngModel)]="currentUpdateMaterial.price" name="price" required min="0" />
                      </mat-form-field>
                    <!-- Precio de Costo -->
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Precio de Costo</mat-label>
                      <input type="number" matInput [(ngModel)]="currentUpdateMaterial.costPrice" name="costPrice" [disabled]="ERPActive"
                        min="0"
                        (blur)="formatCostPrice(currentUpdateMaterial)"
                        [matTooltip]="ERPActive ? 'El precio de costo se gestiona desde el ERP.' : ''" matTooltipPosition="above" />
                    </mat-form-field>
                    </div>
                  </div>
                </div>
              </app-form-section>

              <!-- SECCIÓN: Configuración de Producto -->
              <app-form-section
                title="Configuración de Producto"
                icon="category"
                color="green"
                class="space-y-4 mb-4">
                <div class="space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="w-full">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Compañía</label>
                      <ng-select [(ngModel)]="currentUpdateMaterial.company" [items]="companyList" bindLabel="name"
                        bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía" name="companyId"
                        [compareWith]="compareById" (ngModelChange)="onCompanySelectionChange($event)" [appendTo]="'body'"
                        required>
                      </ng-select>
                    </div>
                    <div class="w-full">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">División</label>
                      <ng-select [(ngModel)]="currentUpdateMaterial.division" [items]="divisionList" bindLabel="name"
                        bindValue="_id" [searchable]="true" placeholder="Seleccione una división" name="divisionId"
                        (ngModelChange)="onDivisionSelectionChange($event)" [compareWith]="compareById" [appendTo]="'body'"
                        required>
                      </ng-select>
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Requisitos</mat-label>
                      <mat-select name="requirements" [(ngModel)]="currentUpdateMaterial.requirements"
                        placeholder="Seleccione requisito(s)" multiple>
                        <mat-option *ngFor="let req of requirementList" [value]="req._id">{{ req.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Clasificación</mat-label>
                      <mat-select name="classifications" [(ngModel)]="currentUpdateMaterial.classifications">
                        <mat-option *ngFor="let classification of classificationList" [value]="classification.value">{{
                          classification.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="grid grid-cols-2 gap-4">
                    <div class="w-full">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Marca de Material</label>
                      <ng-select [(ngModel)]="currentUpdateMaterial.materialBrand" [items]="materialBrandList"
                        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una marca"
                        name="materialBrandId" (ngModelChange)="onMaterialBrandSelectionChange($event)"
                        [compareWith]="compareById" [appendTo]="'body'">
                      </ng-select>
                    </div>
                    <div class="w-full">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Material</label>
                      <ng-select [(ngModel)]="currentUpdateMaterial.type" [items]="materialTypeList" bindLabel="name"
                        bindValue="_id" [searchable]="true" placeholder="Seleccione un tipo de material" name="materialTypeId"
                        (ngModelChange)="onMaterialTypeSelectionChange($event)" [compareWith]="compareById"
                        [appendTo]="'body'">
                      </ng-select>
                    </div>
                  </div>
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Grupo de Material</mat-label>
                    <mat-select [(ngModel)]="currentUpdateMaterial.materialGroups" name="materialGroups" multiple required>
                      <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchMaterialGroup" [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="
                            isProjectTree
                              ? filterTree($event)
                              : changueOptionsGroupMaterial($event)
                          " placeholderLabel="Buscar..." noEntriesFoundLabel="No se encontraron resultados">
                        </ngx-mat-select-search>
                      </mat-option>
                      @if (!isProjectTree) {
                      @for (group of listCategories; track group) {
                      <mat-option [value]="group._id">
                        <b>{{ group.code }}</b> - {{ group.name }}
                      </mat-option>
                      }
                      } @else {
                      <mat-optgroup *ngFor="let group of listCategories" [label]="group.name">
                        <mat-option *ngFor="let subgroup of group.children" [value]="subgroup._id">
                          <ng-container *ngIf="getCode(subgroup) as code">
                            <b class="f-12">{{ code }}</b> -
                          </ng-container>
                          {{ subgroup.name }}
                        </mat-option>
                      </mat-optgroup>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </app-form-section>

              <!-- SECCIÓN: Unidades de Medida -->
              <app-form-section
                title="Unidades de Medida"
                icon="straighten"
                color="purple"
                class="space-y-4 mb-4">
                <div class="space-y-4">
                  <div class="grid grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Embalaje</mat-label>
                      <mat-select [(ngModel)]="currentUpdateMaterial.isPackaged" name="isPackaged">
                        <mat-option *ngFor="let material of materialPackagedList" [value]="material.value">
                          {{ material.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Ventas sin Inventario</mat-label>
                      <mat-select [(ngModel)]="currentUpdateMaterial.canMakeAnOrderWithoutStock" name="canMakeAnOrderWithoutStock">
                        <mat-option *ngFor="let wStock of orderWithoutStockList" [value]="wStock.value">
                          {{ wStock.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div class="w-full">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidad de Medida Base</label>
                      <ng-select [(ngModel)]="currentUpdateMaterial.baseUnitOfMeasure" [items]="baseUnitOfMeasuresList"
                        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una unidad de medida"
                        name="baseunitMeasurementId" (ngModelChange)="onUnitMeasureSelectionChange($event)"
                        [compareWith]="compareById" [appendTo]="'body'" [disabled]="currentUpdateMaterial.baseUnitOfMeasure"
                        required>
                      </ng-select>
                    </div>

                    <div class="w-full">
                      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidad de Medida de Distribución</label>
                      <ng-select [(ngModel)]="currentUpdateMaterial.distributionUnitOfMeasure"
                        [items]="distributionUnitOfMeasureList" bindLabel="name" bindValue="_id" [searchable]="true"
                        placeholder="Seleccione una unidad de medida" name="baseunitDistributionId"
                        (ngModelChange)="onUnitDisributionSelectionChange($event)" [compareWith]="compareById"
                        [appendTo]="'body'">
                      </ng-select>
                    </div>
                  </div>
                </div>
              </app-form-section>

              <!-- SECCIÓN: Configuraciones Adicionales -->
              <app-form-section
                title="Configuraciones Adicionales"
                icon="tune"
                color="orange"
                class="space-y-4 mb-4">
                <div class="flex flex-col gap-y-4">
                  <app-toggle-option
                    [(ngModel)]="currentUpdateMaterial.acceptChange"
                    name="acceptChange"
                    title="Acepta Cambio de Producto"
                    description="Activa esta opción si el material acepta cambios de producto durante los pedidos"
                    icon="sync"
                    iconColor="green">
                  </app-toggle-option>

                  <app-toggle-option
                    [(ngModel)]="currentUpdateMaterial.acceptReturn"
                    name="acceptReturn"
                    title="Acepta Devolución de Producto"
                    description="Activa esta opción si el material acepta devoluciones de los clientes"
                    icon="keyboard_return"
                    iconColor="blue">
                  </app-toggle-option>

                  <app-toggle-option
                    [(ngModel)]="currentUpdateMaterial.UMPActive"
                    name="UMPActive"
                    title="Unidad de Medida Paralela"
                    description="Activa esta opción si el material usará unidades de medida paralelas (UMP) para su gestión"
                    icon="swap_horiz"
                    iconColor="purple">
                  </app-toggle-option>

                  <app-toggle-option
                    [(ngModel)]="currentUpdateMaterial.batchControlActive"
                    name="batchControlActive"
                    title="Control Activo de Lote"
                    description="Activa esta opción si el material requiere control de lotes para trazabilidad"
                    icon="inventory"
                    iconColor="orange">
                  </app-toggle-option>
                </div>
              </app-form-section>

              <!-- SECCIÓN: Almacenes -->
              <app-material-warehouse-assignment
                [selectedWarehouses]="selectedWarehousesEdit"
                [availableInAllWarehouses]="availableInAllWarehousesEdit"
                (warehousesChange)="onWarehousesEditChange($event)"
                (formValidityChange)="onWarehouseEditValidityChange($event)">
              </app-material-warehouse-assignment>
            </form>
          </mat-tab>
          <mat-tab label="Cadena de Distribución">
            <div class="table-container">
              <table mat-table [dataSource]="currentUpdateMaterial.distributionChains">
                <!-- Define columns here -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Nombre</th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="channel">
                  <th mat-header-cell *matHeaderCellDef>Canal</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.channel?.name }}
                  </td>
                </ng-container>
                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                    <mat-slide-toggle [checked]="element.statusId === 1"
                      (change)="onStatusChangeChain($event.checked, element)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button color="primary" mat-button (click)="openDistributionChainModal()"
                      matTooltip="Nuevo Registro">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                      <button mat-icon-button (click)="openDistributionChainModal(element)"
                        matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button mat-icon-button (click)="openDeleteChain(element)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsChain"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsChain"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Impuesto">
            <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
              <mat-form-field appearance="fill" class="modal-input">
                <mat-label>Nombre</mat-label>
                <input matInput [(ngModel)]="currentCreateTax.name" name="name" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Porcentaje</mat-label>
                <input type="number" matInput [(ngModel)]="currentCreateTax.percentage" name="percentage" required />
              </mat-form-field>
            </form>

            <div class="flex justify-end mt-2">
              <button mat-raised-button color="primary" (click)="
                  isEditingTax ? updateTax(currentCreateTax._id) : createTax()
                ">
                {{ isEditingTax ? "Actualizar" : "Agregar" }}
              </button>
            </div>
          </mat-tab>
          <mat-tab label="Dimensiones">
            <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
              <mat-form-field appearance="fill" class="modal-input">
                <mat-label>Altura</mat-label>
                <input type="number" matInput [(ngModel)]="currentCreateDimension.height" name="height" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Ancho</mat-label>
                <input type="number" matInput [(ngModel)]="currentCreateDimension.width" name="width" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Largo</mat-label>
                <input matInput type="number" [(ngModel)]="currentCreateDimension.length" name="length" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Peso Bruto</mat-label>
                <input type="number" matInput [(ngModel)]="currentCreateDimension.grossWeight" name="grossWeight"
                  required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Peso Neto</mat-label>
                <input type="number" matInput [(ngModel)]="currentCreateDimension.netWeight" name="netWeight"
                  required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Volumen</mat-label>
                <input type="number" matInput [(ngModel)]="currentCreateDimension.volume" name="volume" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Código de Peso</mat-label>
                <input matInput [(ngModel)]="currentCreateDimension.weightUnitOfMeasureCode"
                  name="weightUnitOfMeasureCode" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Código de Volumen</mat-label>
                <input matInput [(ngModel)]="currentCreateDimension.volumeUnitOfMeasureCode"
                  name="volumeUnitOfMeasureCode" required />
              </mat-form-field>
            </form>

            <div class="flex justify-end mt-2">
              <button mat-raised-button color="primary" (click)="
                  isEditingDimension
                    ? updateDimension(currentCreateDimension._id)
                    : createDimension()
                ">
                {{ isEditingDimension ? "Actualizar" : "Agregar" }}
              </button>
            </div>
          </mat-tab>
          <mat-tab label="Campos de usuario" *ngIf="fieldsMasterDataStatus">
            <app-user-fields-configuration [fields]="fieldsMasterData" [model]="currentUpdateMaterial"></app-user-fields-configuration>
          </mat-tab>
          <mat-tab label="Materiales Relacionados">
            <!-- <div class="col-span-1">
              <label for="group-select">Materiales Relacionados</label>
              <ng-select
                [(ngModel)]="currentUpdateMaterial.relatedMaterialIds"
                [items]="materialRelatedList"
                bindLabel="name"
                bindValue="_id"
                [searchable]="true"
                [multiple]="true"
                placeholder="Seleccione materiales"
                name="relatedMaterialIds"
                [compareWith]="compareMaterialById"
                (ngModelChange)="onMaterialRelatedSelectionChange($event)"
                [appendTo]="'body'"
                required
              >
              </ng-select>
            </div> -->

            <form #createForm="ngForm">
              <div class="md:flex items-center text-center">
                <mat-form-field class="w-full">
                  <mat-select [(ngModel)]="currentUpdateMaterial.relatedMaterialIds" name="relatedMaterialIds">
                    <mat-option>
                      <ngx-mat-select-search [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                        noEntriesFoundLabel="No se encontraron resultados">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (item of materialRelatedList; track item) {
                    <mat-option [value]="item">
                      <b>{{ item.code }}</b> - {{ item.name }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <button mat-icon-button color="primary" (click)="addRelatedMaterial()" [disabled]="
                    !currentUpdateMaterial.relatedMaterialIds ||
                    currentUpdateMaterial.relatedMaterialIds.length === 0
                  " matTooltip="Agregar material relacionado">
                  <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                </button>
              </div>
              <div class="flex justify-start mb-4 mt-4">
                <mat-form-field class="w-full md:w-1/3" class="fuse-mat-dense fuse-mat-rounded min-w-64"
                  subscriptSizing="dynamic">
                  <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                  <input matInput placeholder="Buscar" autocomplete="off" (input)="searchInDataSourceItem($event)" />
                </mat-form-field>
              </div>
              <div class="col-span-4" style="max-height: 300px; overflow-y: auto">
                <table mat-table [dataSource]="dataSourceItem" class="min-w-500 overflow-y-visible mat-elevation-z">
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef>Código</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.externalKeys?.code }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.name }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <div class="button-container">
                        <button (click)="deleteItem(i)" mat-icon-button>
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsMR" class="sticky top-0 z-10 bg-white"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsMR"></tr>
                </table>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Lista de Material">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Lista</mat-label>
              <mat-select name="materialListId" [(ngModel)]="currentUpdateMaterial.materialListId">
                <mat-option>
                  <ngx-mat-select-search [(ngModel)]="searchMaterialList" [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="changueOptionsMaterialList($event)" placeholderLabel="Buscar..."
                    noEntriesFoundLabel="No se encontraron resultados">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let list of listFilterMaterialList" [value]="list._id">
                  {{ list.name }}
                </mat-option>
              </mat-select>
              <button mat-icon-button matSuffix *ngIf="currentUpdateMaterial.materialListId" (click)="clearSelection()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-tab>
          <mat-tab label="Módulos">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Subaplicaciones</mat-label>
              <mat-select [formControl]="subMultiCtrl" [compareWith]="compareFn" multiple>
                @for (aplication of applicationList; track aplication) {
                <mat-optgroup [label]="aplication.name">
                  @for (
                  subaplication of aplication.subApplications;
                  track subaplication
                  ) {
                  <mat-option [value]="subaplication._id">
                    {{ subaplication.name }}
                  </mat-option>
                  }
                </mat-optgroup>
                }
              </mat-select>
            </mat-form-field>
          </mat-tab>
        </mat-tab-group>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="true"
          [disabled]="!editForm.valid || !isWarehouseEditFormValid"
          [matTooltip]="getEditDisabledTooltip(editForm.valid)">
          <!--|| groupMultiCtrl.invalid-->
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar Unit -->
    <ng-template #deleteModalUnit let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteModalOrder let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [division]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    <app-materials-management-filters [form]="form" [materialGroup]="true" [materialBrand]="true" [isMultiple]="true" [loadData]="loadFiltersData">
    </app-materials-management-filters>
  </app-filter>
</mat-sidenav-container>